<template>
    <div class="page activity-list">
        <list-skeleton v-if="loading"></list-skeleton>

        <div v-else>
            <div class="year" @click="yearPicker = true">
                {{ year }} <img src="/static/bytx/activity_list_filter_icon.svg" />
            </div>

            <van-popup v-model="yearPicker" position="bottom">
                <van-picker show-toolbar :columns="years" @confirm="onYearConfirm" @cancel="positionPicker = false" />
            </van-popup>

            <div class="tags">
                <van-tabs type="card" :swipeable="true" v-model="month" @click="chooseMonth">
                    <van-tab v-for="(item, index) in months" :key="index" :title="item"></van-tab>
                </van-tabs>
                <div class="clear"></div>
            </div>

            <div v-if="finished && finished.length > 0" :class="'activity-list-section ' + more">
                <van-row
                    class="activity-list-section-box"
                    @click="go_detail(item)"
                    v-for="item in finished"
                    :key="item.id"
                >
                    <div class="activity-list-section-left">
                        <van-image
                            fit="cover"
                            class="activity-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div
                            v-if="item.type_text === '活动直播' && item.live && item.live.live_status == 1"
                            class="activity-list-section-left-zl active"
                        >
                            <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> 直播中
                        </div>
                        <div v-else class="activity-list-section-left-zl">
                            <span v-if="item.type_text === '活动直播' && item.live">
                                <span v-if="item.live.live_status === 0">直播预约</span>
                                <span v-if="item.live.live_status > 1">直播回放</span>
                            </span>
                            <span v-else>
                                {{ item.type_text }}
                            </span>
                        </div>
                    </div>
                    <div class="activity-list-section-right">
                        <div v-if="item.status_text === '进行中'" class="activity-list-section-right-tags active">
                            {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '直播中'" class="activity-list-section-right-tags current">
                            <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '已结束'" class="activity-list-section-right-tags end">
                            <img src="/static/bytx/activity_list_done_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '未开始'" class="activity-list-section-right-tags end">
                            <img src="/static/bytx/activity_list_done_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '预告'" class="activity-list-section-right-tags appoint">
                            <img src="/static/bytx/activity_list_preview_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '已预约'" class="activity-list-section-right-tags appoint">
                            <img src="/static/bytx/activity_list_preview_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div class="activity-list-section-right-time">
                            {{ item.start_at
                            }}{{
                                item.ends_at_timestamp != 0
                                    ? item.start_at != item.ends_at
                                        ? ' ~ ' + item.ends_at
                                        : ''
                                    : ''
                            }}
                        </div>
                        <div class="activity-list-section-right-title">{{ item.title }}</div>
                    </div>
                    <div class="clear"></div>
                </van-row>
            </div>

            <div v-if="!more && finished.length > 0" class="activity-list-pull-more" @click="showMore()">
                查看已结束的活动 <img src="/static/bytx/activity_list_pulldown_icon.svg" alt="" />
            </div>
            <div v-else-if="more && finished.length > 0" class="activity-list-pull-more" @click="showMore()">
                收起已结束的活动 <img src="/static/bytx/activity_list_pullup_icon.svg" alt="" />
            </div>

            <div v-if="un_finished && un_finished.length > 0" class="activity-list-section">
                <van-row
                    class="activity-list-section-box"
                    @click="go_detail(item)"
                    v-for="item in un_finished"
                    :key="item.id"
                >
                    <div class="activity-list-section-left">
                        <van-image
                            fit="cover"
                            class="activity-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div
                            v-if="item.type_text === '活动直播' && item.live && item.live.live_status == 1"
                            class="activity-list-section-left-zl active"
                        >
                            <img src="/static/bytx/activity_list_live_icon.gif" alt="" />直播中
                        </div>
                        <div v-else class="activity-list-section-left-zl">
                            <span v-if="item.type_text === '活动直播' && item.live">
                                <span v-if="item.live.live_status === 0">直播预约</span>
                                <span v-if="item.live.live_status > 1">直播回放</span>
                            </span>
                            <span v-else>
                                {{ item.type_text }}
                            </span>
                        </div>
                    </div>
                    <div class="activity-list-section-right">
                        <div v-if="item.status_text === '进行中'" class="activity-list-section-right-tags active">
                            {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '直播中'" class="activity-list-section-right-tags current">
                            <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '已结束'" class="activity-list-section-right-tags end">
                            <img src="/static/bytx/activity_list_done_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '未开始'" class="activity-list-section-right-tags end">
                            <img src="/static/bytx/activity_list_done_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '预告'" class="activity-list-section-right-tags appoint">
                            <img src="/static/bytx/activity_list_preview_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div v-else-if="item.status_text === '已预约'" class="activity-list-section-right-tags appoint">
                            <img src="/static/bytx/activity_list_preview_icon.svg" alt="" /> {{ item.status_text }}
                        </div>
                        <div class="activity-list-section-right-time">
                            {{ item.start_at
                            }}{{
                                item.ends_at_timestamp != 0
                                    ? item.start_at != item.ends_at
                                        ? ' ~ ' + item.ends_at
                                        : ''
                                    : ''
                            }}
                        </div>
                        <div class="activity-list-section-right-title">{{ item.title }}</div>
                    </div>
                    <div class="clear"></div>
                </van-row>
            </div>

            <van-empty
                v-if="finished.length == 0 && un_finished.length == 0"
                description=""
                image="/static/img/pic_blank_content.svg"
            >
                <template slot="description">
                    <div style="text-align: center">博医同行持续更新中…</div>
                    <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                    <div style="text-align: center;margin-top: 24px">
                        <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                            返回首页
                        </van-button>
                    </div>
                </template>
            </van-empty>
        </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import listSkeleton from '@/skeleton/listSkeleton'

export default {
    name: 'activity-list',
    components: {
        'list-skeleton': listSkeleton
    },
    data() {
        return {
            year: '2022',
            years: ['2020', '2021', '2022', '2023'],
            month: '',
            months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],

            value: '',
            active: '',
            recommend: [],
            list: [],
            loading: true,

            finished: [],
            un_finished: [],

            more: false,

            yearPicker: false
        }
    },
    methods: {
        showMore() {
            this.more = !this.more
        },
        fetch(scene) {
            if (scene === 'list') {
                let params = {
                    date: this.date,
                    pageSize: 999
                }
                Interface.getData('get', Interface.activity.list, params).then(res => {
                    if (res.data.activity_finished) {
                        this.finished = res.data.activity_finished
                    } else {
                        this.finished = []
                    }
                    if (res.data.activity_un_finished) {
                        this.un_finished = res.data.activity_un_finished
                    } else {
                        this.un_finished = []
                    }
                    if (this.un_finished.length == 0) {
                        this.more = true
                    } else {
                        this.more = false
                    }

                    Interface.getShareInfo(this, '近期活动——博医同行', '', '每日战友活动精选，随时查看随时参与')
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            }
        },
        go_detail(item) {
            if (item.live_id > 0) {
                if (item.live.live_status === 0) {
                    this.$router.push({ name: 'live-detail', params: { id: item.live_id } })
                } else {
                    this.$router.push({ name: 'live-detail-home', params: { id: item.live_id } })
                }
            } else {
                this.$router.push({
                    name: 'activity-detail',
                    params: { id: item.id }
                })
            }
        },
        chooseMonth() {
            let month = this.month + 1
            this.date = this.year + '-' + (month >= 10 ? month : '0' + month)
            this.fetch('list')
        },
        onYearConfirm(val, i) {
            this.year = val
            this.chooseMonth()
            this.yearPicker = false
        }
    },
    created() {
        let time = new Date()
        if(this.$route.params.month) {
            this.month = parseInt(this.$route.params.month)-1
        } else {
            this.month = time.getMonth()
        }
        if(this.$route.params.year) {
            this.year = parseInt(this.$route.params.year)
        } else {
            this.year = time.getFullYear()
        }
        this.chooseMonth()
        sessionStorage.removeItem('search_data')
    }
}
</script>
<style lang="scss">
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/activity/list/index.vue